import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLaptopCode,
  faCode,
  faRobot,
} from "@fortawesome/free-solid-svg-icons";
import Firefly from "./Firefly";
import "../App.css";
import { useEffect, useState } from "react";

const ROLES = [
  { icon: faLaptopCode, label: "Software Engineer" },
  { icon: faCode, label: "Full-Stack Web Developer" },
  { icon: faRobot, label: "AI Engineer" },
];

export default function Hero() {
  const [fireflies, setFireflies] = useState([]);

  useEffect(() => {
    const swarm = [];
    for (let i = 0; i < 28; i++) {
      swarm.push({
        size: 2 + Math.random() * 5,
        drift1: Math.random() * 18 - 9,
        drift2: Math.random() * 18 - 9,
        left: Math.random() * 100,
        animationDuration: 9 + Math.random() * 14,
        animationDelay: Math.random() * 20,
        blur: Math.random() > 0.55 ? 1 : 0,
      });
    }
    setFireflies(swarm);
  }, []);

  return (
    <section className="relative min-h-screen bg-[#081712] text-[#F1E9D8] flex items-center justify-center overflow-hidden grain">
      <div id="fireflies-container">
        {fireflies.map((f, index) => (
          <Firefly key={index} {...f} />
        ))}
      </div>

      {/* layered atmospheric glows */}
      <div className="pointer-events-none absolute -top-20 -left-20 w-[36rem] h-[36rem] rounded-full bg-[#26502F] opacity-40 blur-[130px]" />
      <div className="pointer-events-none absolute bottom-0 right-0 w-[30rem] h-[30rem] rounded-full bg-[#D4AF6A] opacity-[0.08] blur-[140px]" />

      <div className="max-w-2xl mx-auto px-6 md:px-10 relative z-10 flex flex-col items-center text-center">
        <div className="flex items-center gap-3 mb-6">
          <span className="w-8 h-px bg-[#D4AF6A]" />
          <p className="text-sm tracking-[0.2em] uppercase text-[#93A894]">
            Portfolio
          </p>
          <span className="w-8 h-px bg-[#D4AF6A]" />
        </div>

        <p className="text-base text-[#93A894] mb-3">
          Salaam, and welcome. My name is
        </p>

        <h1 className="font-display text-5xl md:text-7xl font-semibold leading-[0.98] mb-4 text-gold-gradient">
          Hadda Hassani
        </h1>

        <p className="font-display italic text-xl md:text-2xl text-[#D9D2C2] mb-12 max-w-lg">
          building calm, considered software.
        </p>

        <ul className="flex flex-wrap justify-center gap-4 mb-14">
          {ROLES.map((role) => (
            <li
              key={role.label}
              className="flex items-center gap-2 text-sm border border-[#D4AF6A]/30 bg-white/[0.03] px-4 py-2.5 rounded-full hover-glow"
            >
              <FontAwesomeIcon className="text-[#D4AF6A]" icon={role.icon} />
              <span>{role.label}</span>
            </li>
          ))}
        </ul>

        <div className="flex flex-wrap justify-center gap-4">
          <a
            href="#contact"
            className="hover-glow inline-flex items-center gap-3 text-sm text-[#D9D2C2] border border-white/15 bg-transparent rounded-lg px-8 py-3.5 font-medium transition-colors duration-300 hover:text-[#D4AF6A] hover:border-[#D4AF6A]/60"
          >
            <span>Contact Me</span>
          </a>

          <a
            href="#projects"
            className="group relative inline-flex items-center gap-3 text-sm text-[#081712] bg-[#D4AF6A] px-8 py-4 overflow-hidden rounded-lg font-medium"
          >
            <span className="relative z-10">View My Work</span>
            <svg
              className="relative z-10 w-3.5 h-3.5 transition-transform group-hover:translate-x-1"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M1 8h13M8 1l6 7-6 7"
                stroke="#081712"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className="absolute inset-0 bg-[#F1E9D8] scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-300" />
          </a>
        </div>
      </div>

      <div className="scroll-cue absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-[#93A894]">
        <span className="text-xs tracking-widest uppercase">Scroll</span>
        <svg width="14" height="20" viewBox="0 0 14 20" fill="none">
          <rect
            x="1"
            y="1"
            width="12"
            height="18"
            rx="6"
            stroke="#D4AF6A"
            strokeOpacity="0.6"
          />
          <circle cx="7" cy="6" r="1.6" fill="#D4AF6A" />
        </svg>
      </div>
    </section>
  );
}
